export const optionMapper = (item) => ({ value: item, text: item });
export const bannerTypeOptions = ["DEEPLINK", "OFFER"].map(optionMapper);

export const statusOptions = ["ACTIVE", "DISABLED"].map(optionMapper);
export const isActiveOption = [
  { value: true, text: "ACTIVE" },
  { value: false, text: "DISABLED" },
];

export const isFlagOption = [
  { value: 1, text: "ACTIVE" },
  { value: 0, text: "DISABLED" },
];

export const offerLinkSourceOptions = [
  { value: "AFFISE", text: "Affise" },
  { value: "SAPPHYRE", text: "Sapphyre" },
];
export const disabledStatusOptions = ["DISABLED"].map(optionMapper);

export const redirectionFlagOptions = [
  { value: "REFER_AND_EARN", text: "REFER AND EARN" },
];

export const offerStatusOptions = [
  "ACTIVE",
  "PENDING",
  "PAUSED",
  "DISABLED",
].map(optionMapper);
export const fontFamilyOptions = ["MONTSERRAT", "POPPINS"].map(optionMapper);
export const primeOfferStatusOptions = ["ACTIVE", "PENDING", "DISABLED"].map(
  optionMapper
);
export const challengeActionTypeOptions = [
  "ELITE_OFFER",
  "REFERRAL_BUMPER_REWARD"
].map(
  optionMapper
);
export const activationTypeOptions = [
  "SELF_ACTIVATED",
  "CHALLENGE_ACTIVATED"
].map(
  optionMapper
);
export const challengeTargetSegmentOptions = [
  { label: "Organic", value: "organic" },
  { label: "Referred", value: "referred" },
];
export const shareOfferClickStatusOptions = [
  "PENDING",
  "COMPLETED",
  "DECLINED",
].map(optionMapper);

export const installGoalOptions = [
  "1",
  "__session__",
  "af_login",
].map(optionMapper);

export const iapGoalOptions = [
  "revenue",
  "__iap__",
  "iap_60_coin",
  "af_purchase",
  "bb aos revenue_fb",
  "transaction_199",
  "sgh android revenue - affiliate",
  "iap_success",
  "purchase_successful",
].map(optionMapper);

export const ticketResolutionOptions = [
  { value: true, text: "IS_OFFLINE" },
  { value: false, text: "PENDING" },
];

export const ctaTextOptions = [
  { value: "TRY_NOW", text: "TRY NOW" },
  { value: "REGISTER_TODAY", text: "REGISTER TODAY" },
];

export const primeOfferTagOptions = [
  { value: "Popular", text: "Popular" },
  { value: "Exclusive", text: "Exclusive" },
  { value: "High Reward", text: "High Reward" },
  { value: "Referral", text: "Referral" },
  { value: "Hidden", text: "Hidden" },
  { value: "Popular_apk", text: "Popular_apk" },
  { value: "Exclusive_apk", text: "Exclusive_apk" },
  { value: "High Reward_apk", text: "High Reward_apk" },
  { value: "Referral_apk", text: "Referral_apk" },
  { value: "Hidden_apk", text: "Hidden_apk" },
  { value: "apk", text: "apk" },
];

export const eliteOfferTagOptions = [
  { value: "Popular", text: "Popular" },
  { value: "Exclusive", text: "Exclusive" },
  { value: "High Reward", text: "High Reward" },
  { value: "Referral", text: "Referral" },
  { value: "Hidden", text: "Hidden" },
  { value: "Popular_apk", text: "Popular_apk" },
  { value: "Exclusive_apk", text: "Exclusive_apk" },
  { value: "High Reward_apk", text: "High Reward_apk" },
  { value: "Referral_apk", text: "Referral_apk" },
  { value: "Hidden_apk", text: "Hidden_apk" },
  { value: "apk", text: "apk" },
];

export const scheduleTypeOptions = [
  { value: "NONE", text: "None" },
  { value: "DAILY", text: "Daily" },
  { value: "CUSTOM_RANGE", text: "Custom Range" },
];

export const activityTypeOptions = [
  { value: "ELITE_OFFER_PLAYTIME", text: "Elite Offer Playtime" },
  { value: "SHOPPING", text: "Shopping" },
  { value: "PRIME_OFFER", text: "Prime Offer" },
  { value: "PRIME_OFFER_RETENTION", text: "Prime Offer Retention" },
  { value: "ELITE_OFFER", text: "Elite Offer" },
  { value: "EPIC_OFFER", text: "Epic Offer" },
  { value: "PAYOUT_TRANSFER", text: "Payout Transfer" },
  { value: "CONTACT_US", text: "Contact Us" },
  { value: "FEEDBACK", text: "Feedback" },
  { value: "STORE_RTO", text: "Store RTO" },
];

export const ticketStatus = [
  { value: "RECEIVED", text: "RECEIVED" },
  { value: "IN_PROGRESS", text: "IN_PROGRESS" },
  { value: "HOLD", text: "HOLD" },
  { value: "RESOLVED", text: "RESOLVED" },
  { value: "CLOSED", text: "CLOSED" },
];

export const ctaTextOptionsArticles = [
  { value: "KNOW_MORE", text: "KNOW MORE" },
  { value: "READ_MORE", text: "READ MORE" },
  { value: "CLICK_HERE", text: "CLICK HERE" },
  { value: "GET_STARTED", text: "GET STARTED" },
  { value: "LEARN_MORE", text: "LEARN MORE" },
];
export const advertiserStatusOptions = ["ACTIVE", "DISABLED", "PAUSED"].map(
  optionMapper
);
export const remoteConfigInputTypeOptions = [
  "NUMBER",
  "STRING",
  "BOOLEAN",
  "JSON",
].map(optionMapper);

export const categoryTypeOptions = ["PARENT", "CUSTOM"].map(optionMapper);

export const goalTitleOptions = [
  { value: "Sale", text: "Sale" },
  { value: "Leads", text: "Leads" },
  { value: "Signup", text: "Signup" },
  { value: "Signin", text: "Signin" },
  { value: "Register", text: "Register" },
  { value: "Application", text: "Application" },
  { value: "D0Sale", text: "D0Sale" },
  { value: "D7Sale", text: "D7Sale" },
  { value: "Install", text: "Install" },
  { value: "Shopper", text: "Shopper" },
  { value: "Listing", text: "Listing" },
  { value: "Load_Money", text: "Load Money" },
  { value: "Journey_Completion", text: "Journey Completion" },
  { value: "Transaction", text: "Transaction" },
  { value: "Loan_Approval", text: "Loan Approval" },
  { value: "Report_Received", text: "Report Received" },
  { value: "Genuine_Install", text: "Genuine Install" },
  { value: "Form_submission", text: "Form submission" },
];

export const payoutTypeOptions = ["FLAT", "PERCENTAGE"].map(optionMapper);

export const trackingTimeUnits = ["DAYS", "HOURS", "MINUTES"].map(optionMapper);

export const currencyOptions = ["INR", "USD"].map(optionMapper);

export const offerTypeOption = ["CPS"].map(optionMapper);

export const offerTypeOptions = ["CPS", "CPV", "CPI", "CPR", "CPAT", "CPC"].map(
  optionMapper
);

export const primeOfferTypeOptions = ["CPL", "CPAT", "CPI", "CPR"].map(
  optionMapper
);

export const primeOfferPlatformOptions = ["ANDROID", "IOS"].map(optionMapper);

export const eliteOfferTypeOptions = ["CPI", "CPR", "CPL", "CPAT", "CPG"].map(
  optionMapper
);
export const partnerOfferNameOptions = ["hangmyads", "All users"].map(optionMapper);

export const epicOfferTypeOptions = [
  // "iCPI",
  // "iCPR",
  // "iCPL",
  // "iCPAT",
  "iCPG",
].map(optionMapper);

export const offerPriorityTypeOptions = ["High", "Medium", "Low"].map(
  optionMapper
);

export const goalStatusOptions = ["PENDING"].map(optionMapper);

export const goalLockedOptions = ["PENDING"].map(optionMapper);

export const goalCategoryOptions = ["NORMAL", "IN_APP", "HIGH_PAYING"].map(
  optionMapper
);
export const transferStatusOptions = [
  "AWAITING_APPROVAL",
  "APPROVED",
  "REJECTED",
].map(optionMapper);

export const emailOptions = [
  "ritik.awasthi@collegedunia.com",
  "narendra.jadaun@collegedunia.com",
  "rudra.singh@collegedunia.com",
  "pranit.malhotra@collegedunia.com",
  "parth.gera@collegedunia.com",
  "naman.bhola@kickcash.in",
  "mahesh.jagtap@collegedunia.com",
  "avastha.kaur@collegedunia.com",
  "rudraksh.sood@collegedunia.com",
  "hriday.sehgal@collegedunia.com",
  "manalika.sharma@collegedunia.com",
  "sumit.gupta@collegedunia.com",
].map(optionMapper);

export const playtypeOptions = ["DAILY_PAY", "ONE_TIME_PAY"].map(optionMapper);

export const exclusiveBundleGoalColorOptions = ["PURPLE", "YELLOW"].map(
  optionMapper
); // BLUE color is not handled by Frontend

export const exclusiveCategoryOptions = ["PROGRESS", "STREAK", "TOTAL_SUM"].map(
  optionMapper
);

export const bundleCategoryOptions = ["NORMAL"].map(optionMapper);

export const postbackConfigOptions = ["AUTO", "MANUAL"].map(optionMapper);

export const postbackConfigSlicedOptions = ["AUTO"].map(optionMapper);

export const playtimeStatus = ["PENDING"].map(optionMapper);

export const userBlockTypeOptions = ["EMAIL_ID", "USER_ID", "IP_ADDRESS"].map(
  optionMapper
);

export const trafficSourceOptions = ["EMAIL", "SMS", "MOBILE_APP"].map(
  optionMapper
);

export const clickParamsOptions = [
  "appname",
  "gaid",
  "idfa",
  "pid_subpid",
  "subparam1",
  "subparam2",
  "subparam3",
  "subparam4",
  "subparam5",
  "subparam6",
  "subparam7",
  "subparam8",
  "subpid",
];

export const ticketSourceOptions = ["CMS", "APP"].map(optionMapper);
export const ticketTypeOptions = ["STORE", "OFFER", "CATEGORY"].map(
  optionMapper
);
export const allTicketTypeOptions = ["STORE", "OFFER", "CATEGORY", "APP"].map(
  optionMapper
);

export const ticketPriorityOptions = ["HIGH", "MEDIUM", "LOW"].map(
  optionMapper
);

export const ticketStatusOptions = [
  "RECEIVED",
  "IN_PROGRESS",
  "RESOLVED",
  "REJECT",
  "CLOSED",
].map(optionMapper);
export const reporterTicketOptions = ["PENDING", "HOLD", "CLOSE"].map(
  optionMapper
);

export const pushTypeOptions = [
  "STORE",
  "OFFER",
  "CATEGORY",
  "SUB_CATEGORY",
  "TAG",
  "REMOTE_CONFIG",
  "CUSTOM_CATEGORY",
];

export const emailStatusOptions = ["ACTIVE", "BLOCKED", "DISABLED"].map(
  optionMapper
);

export const emailVerificationOptions = ["VERIFIED", "UNVERIFIED"].map(
  optionMapper
);

export const userOfferTypeOptions = ["APP", "WEBSITE"].map(optionMapper);

export const ticketTagOptions = [
  "SHOPPING",
  "KC_PRIME",
  "NEWS",
  "VIDEO",
  "MISC",
].map(optionMapper);

export const offerSourceOptions = [
  "ADMITAD",
  "VCOMMISSION",
  "FLIPKART",
  "OPTIMIZE",
  "PRIMEDIGITAL_KC",
  "BOAT",
].map(optionMapper);

export const callbackStatusOptions = ["PENDING", "PROCESSED", "DUPLICATE"].map(
  optionMapper
);

export const additionalCashbackStatusOptions = [
  { value: "PENDING", text: "PENDING" },
  { value: "APPROVED", text: "APPROVED" },
  { value: "DISCARDED", text: "DISCARDED" },
];

export const couponOptions = ["PRESENT", "ABSENT"].map(optionMapper);
export const couponStatusOptions = ["ENABLED", "DISABLED"].map(optionMapper);

export const userReportOptions = [
  { value: true, text: "COMPLETED" },
  { value: false, text: "IN_PROGRESS" },
];
export const storeStatusOptions = ["ENABLED", "DISABLED"].map(optionMapper);

export const isEarlySaleCashbackOption = [
  { value: true, text: "ACTIVE" },
  { value: false, text: "DISABLED" },
];

export const refundCashFreeStatusOptions = [
  "STARTED",
  "SUCCESS",
  "PENDING",
  "CANCELLED",
  "ONHOLD",
].map(optionMapper);

export const refundStatusOptions = [
  "PENDING",
  "DECLINED",
  "APPROVED",
  "HOLD",
].map(optionMapper);

export const customCategoryOptions = [
  "FEATURED",
  "SEASONAL",
  "FLASH",
  "PRODUCT",
  "STORE",
  "SPOTLIGHT",
  "TRENDING",
  "REWARD",
].map(optionMapper);

export const customCategoryOptionsCps = [
  "FEATURED",
  "SEASONAL",
  "FLASH",
  "PRODUCT",
  "STORE",
].map(optionMapper);

export const customCategoryOptionsCpat = [
  "FEATURED",
  "PRODUCT",
  "SPOTLIGHT",
  "TRENDING",
  "REWARD",
].map(optionMapper);

export const offersOptions = [
  "FEATURED",
  "BANNER",
  "SEASONAL",
  "SPOTLIGHT",
  "FLASH",
  "PRODUCT",
  "COUPON",
  "TRENDING",
  "REWARD",
].map(optionMapper);

export const cpsOffersOptions = [
  "FEATURED",
  "BANNER",
  "SEASONAL",
  "FLASH",
  "PRODUCT",
  "COUPON",
].map(optionMapper);

export const cpatOffersOptions = [
  "FEATURED",
  "BANNER",
  "SPOTLIGHT",
  "PRODUCT",
  "TRENDING",
  "REWARD",
].map(optionMapper);

export const campaignTypeOptions = ["CPS", "CPAT", "CPG", "iCPG"].map(
  optionMapper
);

export const couponTypeOptions = ["EXCLUSIVE", "BANK"].map(optionMapper);

export const jtbdCampaignTypeOptions = ["CPS", "CPAT"].map(optionMapper);

export const campaignOptions = ["ACTIVATION", "RETENTION"].map(optionMapper);

export const targetingTypeOptions = ["REFERRED", "UN_REFERRED"].map(
  optionMapper
);

export const campaignStrategyOptions = [
  "EXTRA_CASHBACK",
  "MULTIPLIER",
  "EXPIRING_WALLET_CASHBACK",
].map(optionMapper);

export const storeTypeOptions = ["D2C", "MARKETPLACE"].map(optionMapper);

export const taskTypeOptions = ["TIME_BASED", "GOAL_BASED"].map(optionMapper);

export const fileTypeOptions = ["PDF", "IMAGE"].map(optionMapper);

export const eliteOfferGoalsStatusOptions = [
  "IN_PROGRESS",
  "PENDING",
  "COMPLETED",
  "EXPIRED",
  "FAILED",
  "ON_HOLD",
].map(optionMapper);

export const eliteOfferStatusOptions = [
  "IN_PROGRESS",
  "PENDING",
  "COMPLETED",
  "DECLINED",
  "EXPIRED",
  "FAILED",
  "ON_HOLD",
].map(optionMapper);
